export interface PaperSeedDraftCategory {
    id: number;
    code: string;
    name: string;
    source_id: number;
}

interface PaperSeedDraftInput {
    title: string;
    abstract?: string | null;
    categories: PaperSeedDraftCategory[];
}

export interface PaperSeedDraft {
    projectName: string;
    categories: PaperSeedDraftCategory[];
    interestText: string;
    include: string[];
    exclude: string[];
}

export function buildPaperSeedDraft({
    title,
    abstract,
    categories,
}: PaperSeedDraftInput): PaperSeedDraft {
    const normalizedTitle = title.trim();
    const normalizedAbstract = abstract?.replace(/\s+/g, ' ').trim();
    // i18n-ignore: scientific-content -- generated research-topic seed content remains untranslated.
    const researchContext = normalizedAbstract
        ? normalizedAbstract.slice(0, 1600)
        : `Track research that develops, tests, or challenges the ideas in "${normalizedTitle}".`;

    return {
        projectName: `Research around ${normalizedTitle}`.slice(0, 120),
        categories,
        interestText: [
            `Use "${normalizedTitle}" as the starting paper for this research digest.`,
            researchContext,
        ].join('\n\n'),
        include: [],
        exclude: [],
    };
}
